import React, { useEffect, useRef } from "react";
import "./landing.css";
import LandingNavbar from "./components/LandingNavbar";
import LandingHero from "./components/LandingHero";
import LandingCodeDemo from "./components/LandingCodeDemo";
import LandingFeatures from "./components/LandingFeatures";
import LandingIntegration from "./components/LandingIntegration";
import LandingPricing from "./components/LandingPricing";
import LandingCta from "./components/LandingCta";
import LandingFooter from "./components/LandingFooter";

const FADE_IN_SELECTOR = ".feature-card, .pricing-card, .step-card";

const Landing = () => {
  const pageRef = useRef(null);

  useEffect(() => {
    document.body.classList.add("landing-active");
    return () => document.body.classList.remove("landing-active");
  }, []);

  useEffect(() => {
    const root = pageRef.current;
    if (!root) {
      return undefined;
    }

    const elements = root.querySelectorAll(FADE_IN_SELECTOR);
    elements.forEach((element) => {
      element.style.opacity = "0";
      element.style.transform = "translateY(20px)";
      element.style.transition = "opacity 0.5s ease, transform 0.5s ease";
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing-page" ref={pageRef}>
      <div className="bg-glow"></div>
      <LandingNavbar />
      <LandingHero />
      <LandingCodeDemo />
      <LandingFeatures />
      <LandingIntegration />
      <LandingPricing />
      {/* <LandingCta /> */}
      <LandingFooter />
    </div>
  );
};

export default Landing;
